export enum CitationStatus {
  PayNow = 'PayNow',
  Warning = 'Warning',
  Pending = 'Pending',
  PastDue = 'PastDue',
  Delinquent = 'Delinquent',
  Canceled = 'Canceled',
  Released = 'Released',
  Paid = 'Paid',
  Suspension = 'Suspension',
  Waived = 'Waived',
  Confirmed = 'Confirmed',
}

export enum RestrictionStateStatus {
  Undefined = 'Undefined',
  Active = 'Active',
  Paused = 'Paused',
}

export const citationStatusMap: Record<CitationStatus, string> = {
  [CitationStatus.PayNow]: 'Pay Now',
  [CitationStatus.Warning]: 'Warning',
  [CitationStatus.Pending]: 'Pending',
  [CitationStatus.PastDue]: 'Past Due',
  [CitationStatus.Delinquent]: 'Delinquent',
  [CitationStatus.Canceled]: 'Canceled',
  [CitationStatus.Released]: 'Released',
  [CitationStatus.Paid]: 'Paid',
  [CitationStatus.Suspension]: 'Suspension',
  [CitationStatus.Waived]: 'Waived',
  [CitationStatus.Confirmed]: 'Confirmed',
};

export const citationStatusColorMap: Record<CitationStatus, string> = {
  [CitationStatus.PayNow]: '#C1FFEA',
  [CitationStatus.Warning]: '#FFD889',
  [CitationStatus.Pending]: '#DCDCDC',
  [CitationStatus.Confirmed]: '#DCDCDC',
  [CitationStatus.PastDue]: '#FFA39E',
  [CitationStatus.Delinquent]: '#FFD889',
  [CitationStatus.Suspension]: '#FFD889',
  [CitationStatus.Canceled]: '#DCDCDC',
  [CitationStatus.Waived]: '#DCDCDC',
  [CitationStatus.Released]: '#C1FFEA',
  [CitationStatus.Paid]: '#C1FFEA',
};

export const citationStatusOptions = [
  { value: CitationStatus.PayNow, label: citationStatusMap[CitationStatus.PayNow] },
  { value: CitationStatus.Warning, label: citationStatusMap[CitationStatus.Warning] },
  { value: CitationStatus.Pending, label: citationStatusMap[CitationStatus.Pending] },
  { value: CitationStatus.PastDue, label: citationStatusMap[CitationStatus.PastDue] },
  { value: CitationStatus.Delinquent, label: citationStatusMap[CitationStatus.Delinquent] },
  { value: CitationStatus.Canceled, label: citationStatusMap[CitationStatus.Canceled] },
  { value: CitationStatus.Released, label: citationStatusMap[CitationStatus.Released] },
  { value: CitationStatus.Paid, label: citationStatusMap[CitationStatus.Paid] },
  { value: CitationStatus.Suspension, label: citationStatusMap[CitationStatus.Suspension] },
  { value: CitationStatus.Waived, label: citationStatusMap[CitationStatus.Waived] },
  { value: CitationStatus.Confirmed, label: citationStatusMap[CitationStatus.Confirmed] },
];
